import React from "react";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Router from "next/router";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
//import HomepageLoader from "../../components/UI/HomepageLoader";
import dynamic from "next/dynamic";
//import OrderTypeSelector from "./OrderTypeSelector";
//import LocationSelector from "./LocationSelector";
//import RestaurantList from "./RestaurantList";
//import ReviewModal from "./ReviewModal";
// import inlineLoader from "../../components/UI/inlineLoader";
import {
  addToCart,
  updateTotalPrice,
  setTotalPrice,
  saveRestaurants,
  selectedRestaurant,
  setNewRestaurant,
  setSelRes,
  setSelCity,
  setCouponResult,
} from "../../store/actions/shop";
import axiosInstance from "../../config/axios";
import { closingHourFn } from "../../helpers/closingTime";
import { deliveryClosingHourFn } from "../../helpers/deliveryClosingTime";
import { usePlacesWidget } from "react-google-autocomplete";

const HomepageLoader = dynamic(
  () => import("../../components/UI/HomepageLoader"),
  {
    ssr: false,
  },
);
const OrderTypeSelector = dynamic(() => import("./OrderTypeSelector"), {
  ssr: false,
});
const LocationSelector = dynamic(() => import("./LocationSelector"), {
  ssr: false,
});
const ReviewModal = dynamic(() => import("./ReviewModal"), {
  ssr: false,
});
const RestaurantList = dynamic(() => import("./RestaurantList"), {
  ssr: false,
});

const MENU_ITEMS = [
  { id: 1, name: "Jollof Rice", image: "/images/jollof-rice-rd.webp" },
  { id: 2, name: "Fried Rice", image: "/images/fried-rice-rd.webp" },
  { id: 3, name: "Burger", image: "/images/burger-rd.webp" },
  { id: 4, name: "Pasta", image: "/images/pasta-rd.webp" },
  { id: 5, name: "Shawarma", image: "/images/sharwama-rd.webp" },
  { id: 6, name: "Dodo", image: "/images/dodo-rd.webp" },
  { id: 7, name: "Chicken", image: "/images/grilled-chicken-rd.webp" },
  { id: 8, name: "Edikaikong", image: "/images/edikaikong-rd.webp" },
  { id: 9, name: "Moi Moi", image: "/images/moi-moi-rd.webp" },
  { id: 10, name: "Meat Pie", image: "/images/meatpie-rd.webp" },
  { id: 11, name: "Turkey", image: "/images/turkey-rd.webp" },
  { id: 12, name: "Yam Pottage", image: "/images/yam-pottage-rd.webp" },
  { id: 13, name: "Doughnut", image: "/images/doughnut.webp" },
];
const HeaderContent = ({ cities }) => {
  const [restaurants, setRestaurants] = useState([]);
  const [closeRestaurant, setCloseRestaurant] = useState({});
  const [restaurantName, setRestaurantName] = useState(null);
  const [inlineLoad, setInlineLoad] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [orderingTime, setOrderingTime] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [windowSize, setWindowSize] = useState({
    height: null,
    width: null,
  });
  const [location, setLocation] = useState({ city: "", state: "" });
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [paymentOption, setPaymentOption] = useState("delivery");
  const [selectedType, setSelectedType] = useState("");
  const [showDiv, setShowDiv] = useState(1);
  const [selectedPlace, setSelectedPlace] = useState("");
  const [deliveryType, setDeliveryType] = useState(null);
  const [locationSelected, setLocationSelected] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [restaurantClosest, setRestaurantClosest] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [houseNumber, setHouseNumber] = useState("");
  const [emptyRes, setEmptyRes] = useState(false);
  const [deliverytracer, setDeliveryTracer] = useState("");
  let token = useSelector((state) => state.auth.token);
  let user = useSelector((state) => state.auth);
  let user_id = user?.user?.id;
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const [review, setReview] = useState("");
  const [rating, setRating] = useState("");
  const [ratingItem, setRatingItem] = useState([]);
  const [reviewStatus, setReviewStatus] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [ratingId, setRatingId] = useState(null);
  const router = useRouter();
  const { "order-id": orderId } = router.query;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [displayIndex, setDisplayIndex] = useState(0);

  const GoogleAutoComplete = dynamic(() => import("../GoogleAutocomplete"), {
    ssr: false,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      // trigger exit animation
      setAnimating(true);

      // after exit animation completes, swap image and trigger enter
      setTimeout(() => {
        setDisplayIndex((prev) => (prev + 1) % MENU_ITEMS.length);
        setCurrentIndex((prev) => (prev + 1) % MENU_ITEMS.length);
        setAnimating(false);
      }, 400); // matches the exit animation duration
    }, 3000); // swap every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const current = MENU_ITEMS[displayIndex];

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ height: window.innerHeight, width: window.innerWidth });
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const mappedCities =
    cities.length > 0 &&
    cities?.map((city) => ({
      value: city.id,
      label: city.city,
    }));

  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchOrderingTime = async () => {
        try {
          const {
            data: { data },
          } = await axiosInstance.get("settings");

          const orderTimeState = closingHourFn(data);
          const deliveryOrderTimeState = deliveryClosingHourFn(data);

          const storedDeliveryType = localStorage.getItem("Deliverytype");
          const storeDelivery = storedDeliveryType
            ? JSON.parse(storedDeliveryType)
            : null;

          if (storeDelivery === "pickup") {
            if (orderTimeState === false) {
              if (
                typeof window !== "undefined" &&
                typeof window.$ !== "undefined" &&
                typeof window.$.fn.modal !== "undefined"
              ) {
                window.$("#storeClosed").modal("show");
              }

              return;
            }

            setOrderingTime(true);
            return;
          }

          if (storeDelivery === "delivery") {
            if (deliveryOrderTimeState === false) {
              if (
                typeof window !== "undefined" &&
                typeof window.$ !== "undefined" &&
                typeof window.$.fn.modal !== "undefined"
              ) {
                window.$("#storeClosed").modal("show");
              }

              return;
            }

            setOrderingTime(true);
          }
        } catch (error) {
          console.error("Error checking ordering time:", error);
        }
      };

      fetchOrderingTime();
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const fetchOrderingTime = async () => {
  //     try {
  //       const {
  //         data: { data },
  //       } = await axiosInstance.get(`settings`);
  //       const orderTimeState = closingHourFn(data);
  //       const deliveryOrderTimeState = deliveryClosingHourFn(data);
  //       const storedDeliveryType = localStorage.getItem("Deliverytype");
  //       const storeDelivery = JSON.parse(storedDeliveryType);

  //       if (storeDelivery === "pickup") {
  //         if (orderTimeState === false) {
  //           if (typeof $ !== "undefined") {
  //             $("#storeClosed").modal("show");
  //           }

  //           return;
  //         } else {
  //           setOrderingTime(true);
  //           return;
  //         }
  //       } else if (storeDelivery === "delivery") {
  //         if (deliveryOrderTimeState === false) {
  //           $("#storeClosed").modal("show");
  //           return;
  //         } else {
  //           setOrderingTime(true);
  //           return;
  //         }
  //       }
  //     } catch (error) {}
  //   };
  //   const run = () => {
  //     fetchOrderingTime();
  //   };

  //   if ("requestIdleCallback" in window) {
  //     requestIdleCallback(run);
  //   } else {
  //     setTimeout(run, 5000);
  //   }
  // }, []);

  useEffect(() => {
    dispatch(setSelCity(null));
    dispatch(setSelRes(null));
    dispatch(selectedRestaurant(null));
    dispatch(addToCart([]));
    dispatch(setCouponResult(null));
    dispatch(updateTotalPrice(0));
    dispatch(setTotalPrice());
    Cookies.remove("selectedRestaurant");
  }, []);

  const handleCityInputChange = (val) => {
    setIsLoading(true);
    setInlineLoad(1);
    setTimeout(() => {
      setIsLoading(false);
      setInlineLoad(0);
    }, 1000);
    setRestaurantName(null);
    let restaurants = cities.find((city) => city.id === val.value).restaurants;
    restaurants = restaurants.map((restaurant) => ({
      ...restaurant,
      value: restaurant.city_id,
      label: restaurant.name,
    }));
    setRestaurants(orderState);
    dispatch(saveRestaurants(restaurants));
    dispatch(setNewRestaurant(restaurants));

    dispatch(setSelCity(val));
  };
  const handleCityInput = (val) => {
    setIsLoading(true);
    setInlineLoad(1);
    setTimeout(() => {
      setIsLoading(false);
      setInlineLoad(0);
    }, 1000);
    setRestaurantName(null);
    let restaurants = cities.find((city) => city.id === val.value).restaurants;
    restaurants = restaurants.map((restaurant) => ({
      ...restaurant,
      value: restaurant.city_id,
      label: restaurant.name,
    }));
    setRestaurants(restaurants);

    dispatch(saveRestaurants(restaurants));
    dispatch(setNewRestaurant(restaurants));
    // Cookies.set('setRestaurants', JSON.stringify(restaurants));
    dispatch(setSelCity(val));
    // Cookies.set('cityFocused', JSON.stringify(val));
  };

  const handleRestaurantInputChange = useCallback(async(value) => {
    if (deliveryType === "'delivery'" || "'pickup'") {
      if (!value?.active) {
        document.getElementById("inactive-modal").click();
        return;
      }
      setIsLoading(true);
      setInlineLoad(1);
      Cookies.remove("totalPrice");
      Cookies.remove("setCart");
      Cookies.remove("orderItem");
      localStorage.removeItem("checkoutToLogin");

      dispatch(selectedRestaurant(value));

      const selectedRestaurantName = JSON.stringify(value.name);
      const duration = value.duration;
      const distance = JSON.stringify(value.distance);
      localStorage.setItem("order-distance", distance);
      localStorage.setItem("order-duration", duration);

      localStorage.setItem("selectedRestaurantName", selectedRestaurantName);
      Cookies.set("selectedRestaurant", JSON.stringify(value));

      const selectedRes = {
        label: value.label,
        value: value.id,
      };

      dispatch(setSelRes(selectedRes));
      sessionStorage.setItem("navigationSource", "internal");
      await closeOrderTypeModal();
       
      Router.push(`/menu/${value.slug}`);
    } else {
      setShowModal(true);
    }
  });

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          setLatitude(latitude);
          setLongitude(longitude);
          getGeolocationData(latitude, longitude);
          fetchOrderingCity(latitude, longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
        },
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  // Function to get city and state from latitude and longitude
  const getGeolocationData = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `
        https://maps.googleapis.com/maps/api/geocode/json?latlng=
        ${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_OPENCAGE_API_KEY}`,
      );

      const data = await response.json();
    } catch (error) {
      console.error("Error fetching geolocation data:", error);
    }
  };

  // Function to fetch nearby restaurants
  const fetchOrderingCity = async (latitude, longitude) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `V1/restaurants/v2/near-me?latitude=${latitude}&longitude=${longitude}&count=10&page=1&type=${deliveryType}`,
      );
      const orderState = response.data.data;
      setRestaurants(orderState);

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching nearby restaurants:", error);
    }
  };

  // Function to handle button click
  const handleButtonClick = () => {
    setIsLoading(true);
    // Function to get current location
    const getCurrentLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLatitude(latitude);
            setLongitude(longitude);

            // Fetch geolocation data
            getGeolocationData(latitude, longitude);

            // Fetch nearby restaurants
            fetchOrderingCity(latitude, longitude);
            setLocationSelected(true);
            searchOrderingCity(latitude, longitude, deliveryType);
            setIsLoading(false);
            handleNext();
          },
          (error) => {
            console.error("Error getting location:", error);
          },
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    const getGeolocationData = async (latitude, longitude) => {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.NEXT_PUBLIC_OPENCAGE_API_KEY}`,
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        setSelectedPlace(data.results[0].formatted_address);
        const houseNumberPattern = /^\d+/;
        const match =
          data.results[0].formatted_address.match(houseNumberPattern);

        let trimmedAddress = null;
        if (match) {
          trimmedAddress = match[0].trim();
          setHouseNumber(trimmedAddress);
        } else {
        }
        const addressData = {
          address: data.results[0].formatted_address,
          lat: latitude,
          long: longitude,
          house_number: trimmedAddress,
          delivery_tracer: deliverytracer,
          order_type: deliveryType,
        };

        localStorage.setItem("addressData", JSON.stringify(addressData));

        localStorage.setItem(
          "selectedPlace",
          JSON.stringify(data.results[0].formatted_address),
        );
      } catch (error) {
        console.error("Error fetching geolocation data:", error);
      }
    };

    const fetchOrderingCity = async (latitude, longitude) => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get(
          `V1/restaurants/v2/near-me?latitude=${latitude}&longitude=${longitude}&count=10&page=1&type=${deliveryType}`,
        );
        const orderState = response.data;
        setRestaurants(orderState.data.data.other_restaurants);
        const nearbyRestaurant = orderState.data.data.restaurant.restaurant;

        setRestaurantClosest(nearbyRestaurant);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching nearby restaurants:", error);
      }
    };

    // Call the function to get current location
    getCurrentLocation();
  };

  const searchOrderingCity = async (latitude, longitude) => {
    const storedDeliveryType = localStorage.getItem("Deliverytype");
    const storeDelivery = JSON.parse(storedDeliveryType);

    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `V1/restaurants/v2/near-me?latitude=${latitude}&longitude=${longitude}&count=10&page=1&type=${storeDelivery}`,
      );

      const orderState = response.data;

      if (
        orderState.data.statusCode >= 200 &&
        orderState.data.statusCode < 300
      ) {
        const otherRestaurants = orderState.data.data.other_restaurants;
        const nearbyRestaurant = orderState.data.data.restaurant.restaurant;

        setRestaurants(otherRestaurants);

        const deliveryTracer = orderState.data.data.delivery_tracer;
        setDeliveryTracer(deliveryTracer);
        setRestaurantClosest(nearbyRestaurant);
        const cartAbandonementData = {
          restaurant_id: nearbyRestaurant.id,
          order_type: deliveryType,
          delivery_address: nearbyRestaurant.address,
          latitude: nearbyRestaurant.latitude,
          longitude: nearbyRestaurant.longitude,
          delivery_tracer: orderState.data.data.delivery_tracer,
        };
        localStorage.setItem(
          "cart_abandonement_data",
          JSON.stringify(cartAbandonementData),
        );
        const defaultAddressData = {
          restaurant_id: nearbyRestaurant.id,
          order_type: deliveryType,
          delivery_address: nearbyRestaurant.address,
          latitude: nearbyRestaurant.latitude,
          longitude: nearbyRestaurant.longitude,
          delivery_tracer: orderState.data.data.delivery_tracer,
        };
        localStorage.setItem(
          "default_address_data",
          JSON.stringify(defaultAddressData),
        );
        localStorage.setItem("delivery_tracer", deliveryTracer);
        localStorage.setItem(
          "cached closest_restaurant",
          JSON.stringify(nearbyRestaurant),
        );
        localStorage.setItem(
          "cached other_restaurant",
          JSON.stringify(otherRestaurants),
        );
        localStorage.setItem(
          "delivery price",
          orderState.data.data.restaurant.restaurant.delivery_price,
        );
      }
      // Update restaurants with only the first 2 items in the array
      else if (
        orderState.data.statusCode === 500 ||
        orderState.data.status === 500
      ) {
        localStorage.removeItem("cached closest_restaurant");
        localStorage.removeItem("cached other_restaurant");
        localStorage.removeItem("delivery price");
        localStorage.removeItem("delivery_tracer");

        setEmptyRes(true);
        setIsLoading(false);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      localStorage.removeItem("cached closest_restaurant");
      localStorage.removeItem("cached other_restaurant");
      localStorage.removeItem("delivery price");
      localStorage.removeItem("delivery_tracer");

      setEmptyRes(true);
      setIsLoading(false);

      console.error("Error fetching nearby restaurants:", error);
    }
  };

  const { ref, autocompleteRef } = usePlacesWidget({
    apiKey: process.env.NEXT_PUBLIC_OPENCAGE_API_KEY,
    options: {
      componentRestrictions: { country: "NG" },
      types: ["address"],
    },
    onPlaceSelected: (place) => {
      const latitude = place.geometry.location.lat();
      const longitude = place.geometry.location.lng();

      setLatitude(latitude);
      setLongitude(longitude);
      setSelectedPlace(place.formatted_address);

      const houseNumberPattern = /^\d+/;
      const match = place.formatted_address.match(houseNumberPattern);

      let trimmedAddress = null;
      if (match) {
        trimmedAddress = match[0].trim();
        setHouseNumber(trimmedAddress);
      }

      setLocationSelected(true);
      localStorage.setItem(
        "selectedPlace",
        JSON.stringify(place.formatted_address),
      );
      const addressData = {
        address: place.formatted_address,
        lat: latitude,
        long: longitude,
        house_number: trimmedAddress,

        // Append the house number here
      };
      localStorage.setItem("addressData", JSON.stringify(addressData));
    },
  });

  const handlePlaceSelect = (place) => {
    const latitude = place.location.latitude;
    const longitude = place.location.longitude;

    setLatitude(latitude);
    setLongitude(longitude);
    setSelectedPlace(place.formattedAddress);

    const houseNumberPattern = /^\d+/;
    const match = place.formattedAddress.match(houseNumberPattern);

    let trimmedAddress = null;
    if (match) {
      trimmedAddress = match[0].trim();
      setHouseNumber(trimmedAddress);
    }

    setLocationSelected(true);
    localStorage.setItem(
      "selectedPlace",
      JSON.stringify(place.formattedAddress),
    );

    const addressData = {
      address: place.formattedAddress,
      lat: latitude,
      long: longitude,
      house_number: trimmedAddress,
    };
    localStorage.setItem("addressData", JSON.stringify(addressData));
  };

  const onchangePaymentOption = (event) => {
    setDeliveryType(event.target.value);
    localStorage.setItem("Deliverytype", JSON.stringify(event.target.value));
    setDelivery(true);
    setShowDiv(2);
  };
  const onShowDivTwo = () => {
    setShowDiv(2);
  };

  const setPickup = () => {
    setDeliveryType("pickup");
    setDelivery(true);
  };
  const handlePrevClick = () => {
    setShowDiv(1);
  };
  const handleSwitchClick = () => {
    if (deliveryType === "pickup") {
      setDeliveryType("delivery");
      localStorage.setItem("Deliverytype", JSON.stringify("delivery"));
      setShowDiv(2);
    } else {
      setDeliveryType("pickup");
      localStorage.setItem("Deliverytype", JSON.stringify("pickup"));
      setShowDiv(2);
    }
  };

  const handleContinueClick = () => {
    $("#closeModal").click();
    setShowDiv(2);
  };
  const handleNextClick = () => {
    setShowDiv(3);
  };

  const handleNext = () => {
    setTimeout(() => {
      setShowDiv(3);
    }, 1500); // 3000 milliseconds = 3 seconds
  };

  const handleLast = () => {
    setShowDiv(4);
  };

  const previousAddressRef = useRef("");
  const cachedData = () => {
    const location = localStorage.getItem("addressData");

    const parsedLocation = JSON.parse(location || "{}");
    const deliveryOption = localStorage.getItem("Deliverytype");
    const parsedDeliveryOption = JSON.parse(deliveryOption);

    // const parsedDeliveryOption = JSON.parse(deliveryOption);
    const nearestRestaurant = localStorage.getItem("cached closest_restaurant");
    const otherRestaurants = localStorage.getItem("cached other_restaurant");
    const cachedDeliveryTracer = localStorage.getItem("delivery_tracer");
    const currentAddress = parsedLocation?.address || "";
    const parsedRestaurant = JSON.parse(nearestRestaurant || "{}");

    if (!currentAddress) {
      setShowDiv(1);
    } else {
      setShowDiv(3);
      setSelectedPlace(currentAddress);
      setDeliveryType(JSON.parse(deliveryOption));
      setLatitude(parsedLocation?.lat);
      setLongitude(parsedLocation?.long);
      const cartAbandonementData = {
        restaurant_id: parsedRestaurant.id,
        order_type: parsedDeliveryOption,
        delivery_address: parsedLocation.address,
        latitude: parsedRestaurant?.latitude,
        longitude: parsedRestaurant?.longitude,
        delivery_tracer: cachedDeliveryTracer,
      };
      localStorage.setItem(
        "cart_abandonement_data",
        JSON.stringify(cartAbandonementData),
      );

      if (nearestRestaurant) {
        typeof nearestRestaurant === "string"
          ? setRestaurantClosest(JSON.parse(nearestRestaurant))
          : null;
      }

      try {
        const parsedOtherRestaurants =
          typeof otherRestaurants === "string"
            ? JSON.parse(otherRestaurants)
            : null;

        setRestaurants(parsedOtherRestaurants.slice(0, 2));
      } catch (err) {
        console.error("Could not parse otherRestaurants", err);
      }

      // Only fire searchOrderingCity if address has changed
      if (
        previousAddressRef.current &&
        previousAddressRef.current !== currentAddress
      ) {
        searchOrderingCity(
          parsedLocation?.lat,
          parsedLocation?.long,
          //parsedDeliveryOption
          deliveryOption,
        );
      }

      // Set current address after comparison
      previousAddressRef.current = currentAddress;
    }
  };

  useEffect(() => {
    const currentAppVersion = process.env.NEXT_PUBLIC_APP_VERSION;
    const storedAppVersion = localStorage.getItem("appVersion");

    if (storedAppVersion !== currentAppVersion) {
      localStorage.clear(); // Clear all localStorage data
      localStorage.setItem("appVersion", currentAppVersion);
    } else {
      cachedData();

      if (emptyRes === true) {
        cachedData();
        window.location.reload();
      }
    }
  }, [emptyRes]);

  const deleteCart = async () => {
    if (loggedIn) {
      try {
        const response = await axiosInstance.delete(
          "V1/cart",

          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
      } catch (error) {}
    }
  };

  const ratingHandler = async () => {
    try {
      const payload = {
        rating_id: rating,
        comment: review,
      };
      const response = await axiosInstance.post(
        `orders/${ratingId}/rate-order`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      document.getElementById("review-complete-modal").click();

      return { response };
    } catch (error) {}
  };

  const handlereview = () => {
    $("#reviewModal").modal("hide");

    document.getElementById("review-complete-modal").click();
  };

  const fetchOrders = async () => {
    try {
      const {
        data: { data: orders },
      } = await axiosInstance.get(`orders/${orderId}?is_order_review=true`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setRatingItem(orders.order_items);
      setRatingId(orders.id);
      if (orders.order_review === null) {
        setReviewStatus("not reviewed");
      }

      setOrderStatus(orders.status);
    } catch (error) {}
  };
  useEffect(() => {
    if (loggedIn && orderId) {
      fetchOrders();
    }
  }, [loggedIn, orderId]);
  useEffect(() => {
    if (
      ratingItem &&
      ratingItem.length > 0 &&
      orderStatus === "Completed" &&
      reviewStatus === "not reviewed"
    ) {
      const timer = setTimeout(() => {
        document.getElementById("review-modal").click();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [ratingItem, orderStatus, reviewStatus]);
 const closeOrderTypeModal = () =>
  new Promise((resolve) => {
    // ── read $ fresh on every call — never cache it between renders ─────────
    const $ = typeof window !== "undefined" ? window.$ : undefined;

    // ── guard: jQuery not loaded yet ─────────────────────────────────────────
    if (!$ || typeof $.fn?.modal !== "function") {
      resolve();
      return;
    }

    const $modal = $("#orderTypeModal");

    // ── guard: modal element doesn't exist or isn't open ─────────────────────
    if (!$modal.length || !$modal.hasClass("show")) {
      resolve();
      return;
    }

    // ── resolve once Bootstrap finishes the fade-out ──────────────────────────
    $modal.one("hidden.bs.modal", () => resolve());
    $modal.modal("hide");

    // ── safety net in case the event never fires ──────────────────────────────
    setTimeout(resolve, 500);
  }).then(() => {
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    document.body.style.removeProperty("overflow");
  });

  return (
    <>
      <section className="header-content home">
        <div className="container">
          <div className="headtext-container">
                {showDiv === 1 && (
                  <div id="first-div" className="first-div">
                  <h5 className="text-center" >
                              How would you like to complete your order?
                            </h5>
                   
                    <p className="text-center">
                      Order delicious meals from Kilimanjaro Restaurants for
                      pickup or delivery. 
                    </p>
                     

                    {/* replaced with component */}
                    <OrderTypeSelector
                      deliveryType={deliveryType}
                      onChangePaymentOption={onchangePaymentOption}
                      onShowDivTwo={() => setShowDiv(2)}
                    />
                  </div>
                )}

                {showDiv === 2 && (
                  // replaced with component
                  <LocationSelector
                    isLoading={isLoading}
                    locationSelected={locationSelected}
                    onButtonClick={handleButtonClick}
                    onPlaceSelect={handlePlaceSelect}
                    onNext={handleNext}
                    onSearchOrderingCity={searchOrderingCity}
                    latitude={latitude}
                    longitude={longitude}
                    deliveryType={deliveryType}
                    onPrevClick={() => setShowDiv(1)}
                  />
                )}

                {showDiv === 3 && (
                  // replaced with component
                  <RestaurantList
                    restaurantClosest={restaurantClosest}
                    restaurants={restaurants}
                    deliveryType={deliveryType}
                    selectedPlace={selectedPlace}
                    isLoading={isLoading}
                    inlineLoad={inlineLoad}
                    onRestaurantSelect={(restaurant) => {
                      handleRestaurantInputChange(restaurant);
                      deleteCart();
                    }}
                    onSwitchClick={handleSwitchClick}
                    onEditLocation={handleContinueClick}
                  />
                )}
              </div>
        </div>


        {/* inactive modal stays here since it's tied to inline button */}
        <button
          type="button"
          className="btn btn-primary"
          data-toggle="modal"
          data-target="#exampleModal"
          id="inactive-modal"
          style={{ display: "none" }}
        >
          Launch demo modal
        </button>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-4">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                style={{ marginLeft: "auto" }}
              >
                <span
                  aria-hidden="true"
                  className="ms-auto"
                  style={{ fontSize: "24px" }}
                >
                  &times;
                </span>
              </button>
              <div className="modal-body">
                <p className="text-center" style={{ fontSize: "24px" }}>
                  This store is currently unavailable for deliveries
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* address modal */}
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          id="addressModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="addressModalLabel"
          aria-hidden={!showModal}
          style={{ display: showModal ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-4">
              <div className="d-flex align-items-center">
                <span
                  aria-label="Close"
                  id="closeModal"
                  style={{
                    marginLeft: "auto",
                    fontSize: "15px",
                    color: "white",
                    cursor: "pointer",
                  }}
                  className="px-4"
                  onClick={() => setShowModal(false)}
                >
                  <img
                    src="/images/x-red.svg"
                    alt="close icon"
                    width={40}
                    height={40}
                  />
                </span>
              </div>
              <div className="modal-body">
                <p className="text-center">
                  We could not retrieve your house number, please enter your
                  house number to ensure a stressless delivery to you
                </p>
                <button
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginBottom: "20px",
                    marginTop: "30px",
                    width: "50%",
                  }}
                  className="btn select-tool"
                  onClick={handleContinueClick}
                >
                  <span className="text">Ok</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* replaced with component */}
        <ReviewModal
          ratingItem={ratingItem}
          rating={rating}
          review={review}
          onRatingChange={setRating}
          onReviewChange={setReview}
          onSubmit={ratingHandler}
        />
      </section>
    </>
  );
};

export default HeaderContent;
